import React from 'react'
import NangoIntegration from '../../Settings/components/integration/Nango'
import IntegrationTopbar from '../Auth/Components/Topbar'
import IntegrationCard from './Components/IntegrationCard'
import { useUserInfo } from '../../../context/user'
import { useAvailableBranding } from '../../../queries/integrations'

const IntegrationsApp = () => {
    const userActiveLocation = useUserInfo()[4]
    // Was axios.get(env.API_URL + "/v1/integrations/available-branding...")
    // fired via useState+useEffect on mount/location-change.
    const { data: integration = [] } = useAvailableBranding(userActiveLocation?.agency_id);

    return (
        <div className=''>
            <IntegrationTopbar />
            <div className='mt-10 !mx-20'>
                <p className='text-2xl font-bold mb-8'>Integrations</p>
                <div className='flex flex-wrap'>
                    {userActiveLocation?.active_integrations?.length > 0 ? integration?.filter((integration) => userActiveLocation?.active_integrations?.includes(integration.provider)).map((integration) => <IntegrationCard key={integration.provider} integration={integration} />) : <><p>No integration enabled for this account</p></>}
                </div>
            </div>
        </div>
    )
}

export default IntegrationsApp